<app-tdo-progress-spinner *ngIf="isLoading" data-cy="insurance-manage-subscribers-loading"></app-tdo-progress-spinner>
<div *ngIf="!isLoading" class="section" style="flex: 1; display: flex; flex-direction: column;" data-cy="insurance-manage-subscribers-container">
  <div class="section-header" style="flex-basis: fit-content;" data-cy="insurance-manage-subscribers-header">
    <div class="section-header-title" data-cy="insurance-manage-subscribers-title">Choose Subscriber</div>
  </div>
  <div class="section-content" style="display: flex; flex-direction: column; flex: 1;" data-cy="insurance-manage-subscribers-content">

    <div style="display: flex" data-cy="insurance-manage-subscribers-options">
      <div style="flex:1" data-cy="insurance-manage-subscribers-checkbox-container">
        <mat-checkbox style="flex-basis: fit-content;" [(ngModel)]="patientIsSubscriber" (ngModelChange)="this.patientIsSubscriberChanged($event)" *ngIf="!this.patientPayment" data-cy="insurance-manage-subscribers-patient-checkbox">
          Subscriber is the patient
        </mat-checkbox>
      </div>
      <div style="flex: 1; text-align: right" data-cy="insurance-manage-subscribers-create-container">
        <button class="tdo-button tdo-save" [disabled]="this.patientIsSubscriber"
                (click)="openCreatePatientComponent()" data-cy="insurance-manage-subscribers-create-button">
          Create a new contact
        </button>
      </div>
    </div>

    <div style="height:385px;" data-cy="insurance-manage-subscribers-table-container">
      <app-tdo-table
        *ngIf="tableModel !== undefined"
        [tdoTableModel]="this.tableModel"
        (actionClick)="onTdoTableItemActionClick($event)"
        (itemSelected)="onTdoTableItemClick($event)"
        [isMultiSelect]="false"
        data-cy="insurance-manage-subscribers-table">
      </app-tdo-table>

    </div>
    <div class="action-container-left" data-cy="insurance-manage-subscribers-actions">
      <div style="flex: 1; text-align: right" data-cy="insurance-manage-subscribers-buttons">
        <button style="margin-right: 12px;" class="tdo-button tdo-close" (click)="closeRef()" data-cy="insurance-manage-subscribers-cancel-button">Cancel</button>
        <button class="tdo-button tdo-save" (click)="save()" data-cy="insurance-manage-subscribers-ok-button">
          Ok
        </button>
      </div>
    </div>
  </div>
</div>
